import { A2AProviderName } from '@nemuru-eng/js-api-client';

import { SinglePaymentProviderIds } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/constants/SinglePaymentMethodsProviderIds';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';
import { SelectOption } from '@/types/selectOption';

export const A2APaymentProviderOptions = (t: GetTextIdTranslationType): SelectOption[] =>
  Object.values(A2AProviderName)
    .map((providerName) => {
      const value = SinglePaymentProviderIds[providerName];
      return {
        value: value,
        display: t(providerName.toLowerCase()) || providerName.toLowerCase(),
      };
    })
    .filter((e) => e.value !== undefined);
